import { useState, useEffect, useRef } from "react";
import moment from "moment";
import { Dialog } from "components2/CommonUI";

// https://usehooks.com/useWindowSize/
const useScreenWidth = () => {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return width;
};

/*
https://getbootstrap.com/docs/5.0/layout/breakpoints/
X-Small	None	<576px
Small	sm	≥576px
Medium	md	≥768px
Large	lg	≥992px
Extra large	xl	≥1200px
Extra extra large	xxl	≥1400px
*/
const useBSScreenBreak = () => {
  const [size, setSize] = useState(null);
  const width = useScreenWidth();

  useEffect(() => {
    if (width >= 1400) {
      setSize("xxl");
    } else if (width >= 1200) {
      setSize("xl");
    } else if (width >= 992) {
      setSize("lg");
    } else if (width >= 768) {
      setSize("md");
    } else if (width >= 576) {
      setSize("sm");
    } else {
      // there is not xs exist in BS, but just
      setSize("xs");
    }
  }, [width]);

  return size;
};

const useOtpTime = () => {
  const [time, setTime] = useState(null);
  let refInterval = useRef();

    useEffect(()=> {
      return ()=> {
        refInterval.current && clearInterval(refInterval.current);
      }
    }, []);

    const start = (timeInSecs) => {
      setTime(timeInSecs);
      refInterval.current = setInterval(()=> {
        setTime((t)=> {
          if(t === 0) {
            setTime(null);
            refInterval.current && clearInterval(refInterval.current);
          } else {
            setTime(t - 1);
          }
        });
      }, 1000);
    };

    const stop = () => {
      refInterval.current && clearInterval(refInterval.current);
      setTime(null);
    }

    return {
      start,
      stop,
      time: time !== null ? moment.utc(time*1000).format("mm:ss") : null,
    }
}

/*const useApiCall = (fn, param, onErr) => {
 return new Promise((resolve, reject)=>{
   fn(param).then(result=>{
     if(result.status !== "SUCCESS") {
       onErr("Unexpected error has occurred. Please try again.");
       resolve([false]);
       return;
     }
     resolve([true, result]);
   })
 });
}*/

// catch and suppress error
const catchEmAll = (fn) => {
  try {
    return fn();
  }catch(e) {
    debugger;
    console.error(e);
    return null;
  }
}

const useWogaa = (action) => {

  const startCancel = () => {
    catchEmAll(()=>window.wogaaCustom.startTransactionalService(window.wogaa.cancel));
    console.log("wogaa start cancel");
  }

  const endCancel = () => {
    catchEmAll(()=>window.wogaaCustom.completeTransactionalService(window.wogaa.cancel));
    console.log("wogaa end cancel");
  }

  const startComplete = () => {
    catchEmAll(()=>window.wogaaCustom.startTransactionalService(window.wogaa.complete));
    console.log("wogaa start complete");
  }

  const endComplete = () => {
    catchEmAll(()=>window.wogaaCustom.completeTransactionalService(window.wogaa.complete));
    console.log("wogaa end complete");
  }

  useEffect(()=>{
    if(action === "start_complete") {
      catchEmAll(()=>window.wogaaCustom.startTransactionalService(window.wogaa.complete));
      console.log("wogaa start complete");
    } else if(action === "end_complete") {
      catchEmAll(()=>window.wogaaCustom.completeTransactionalService(window.wogaa.complete));
      console.log("wogaa end complete");
    }
  }, [action]);

  return { startCancel, endCancel, startComplete, endComplete };
}

const useAdobeDigitalData = ({name, path}) => {
  useEffect(()=>{
    /* digitalData.pageName = name;
    digitalData.pagePath = "/appt/oas" + path; */

    sendAdobeStat({
      name, 
      path: window.aem.basePath + path, 
      isLoggedIn: store.getState().signPassIdentify.isLogin,
      pageURL: window.aem.baseURL + path,
      tokenisedId: store.getState().signPassIdentify.tokenisedId
    });

    /* digitalData = { ...digitalData, pageName: name };

    // document.getElementById("digitalDataSrc").src="https://assets.adobedtm.com/3943c2ab6f0f/6d0beda1e958/launch-a34119b7845c-development.min.js?" + (new Date()).getTime();
    console.log("digitalData", digitalData);
    const ee = new CustomEvent("event-view-end");
    let ret = document.dispatchEvent(ee);
    console.log("#adobe", ret); */

  }, []);
}

export { useScreenWidth, useBSScreenBreak, useOtpTime, useWogaa, useAdobeDigitalData };



